var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"phone"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_c('span',{ref:"number",staticClass:"protectedNumber"})])}
var staticRenderFns = []

export { render, staticRenderFns }